<template>
  <select-field
    name="scoreSetSelector"
    :items="scoreSets"
    :value="currentScoreSet"
    @selected="onSelect"
  >
  </select-field>
</template>

<script>
import $ from 'jQuery';
import { SelectField } from 'vue-bootstrap';

/**
 * The ScoreSetSelector component.
 *
 * Populates a select field with score sets, redirects to the provided URL using pjax.
 */
export default {
  components: {
    SelectField
  },
  props: {
    url: {
      type: String,
      required: true
    },
    scoreSets: {
      type: Array,
      required: true
    },
    currentScoreSet: {
      type: Number,
      default: null
    }
  },
  methods: {
    onSelect(name, selected) {
      if (this.currentScoreSet !== selected) {
        this.redirect(selected);
      }
    },
    redirect(id) {
      $.pjax({
        url: this.url,
        data: 'score-set=' + id,
        container: '#pjaxContainer',
        method: 'GET'
      });
    }
  }
};
</script>
